export const SYS_FONTS = [
  { label: 'Arial', value: 'Arial' }
]

export const WEB_FONTS = [
  { label: 'Arial', value: 'Arial' },
  { label: 'ABB', value: 'ABBVoice' },
  { label: 'Helvetica', value: 'Helvetica' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Market Deco', value: 'Market_Deco'}
]
